export const CustomEnvName = {
  DevelopmentLocalhost: "DevelopmentLocalhost",
  DevelopmentAzure: "DevelopmentAzure",
  StagingAzure: "StagingAzure",
  ProductionAzure: "ProductionAzure",
} as const;
export type CustomEnvName = (typeof CustomEnvName)[keyof typeof CustomEnvName];
